import React, { useId } from 'react';
import type { LucideProps } from 'lucide-react';

/**
 * Protection icon component
 * Custom shield icon from .graphics/client/protection.svg
 */
export const ProtectionIcon: React.FC<LucideProps> = ({ size = 24, className, ...props }) => {
  const id = useId();
  const bodyId = `${id}-body`;
  const stripeId = `${id}-stripe`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <linearGradient
          id={bodyId}
          gradientUnits="userSpaceOnUse"
          x1="3.1418478"
          y1="12"
          x2="20.858152"
          y2="12"
        >
          <stop offset="0" stopColor="#3bd5ff" />
          <stop offset="1" stopColor="#115af5" />
        </linearGradient>
        <linearGradient
          id={stripeId}
          gradientUnits="userSpaceOnUse"
          x1="3.14183"
          y1="12"
          x2="14.02165"
          y2="12"
        >
          <stop offset="0" stopColor="#51d6fe" />
          <stop offset="1" stopColor="#33a0e6" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${bodyId})`}
        stroke="none"
        d="m 11.99998,0.60723295 c -0.0486,0 -0.0972,0.019564 -0.14088,0.056846 C 9.4545,2.7607574 6.17404,4.408527 3.14183,4.408527 v 8.858152 c 0,2.868346 0.94838,4.85766 2.5136,6.460717 1.56522,1.603054 3.81148,2.782428 6.33961,3.655471 0.01,0.0032 0.0198,0.0065 0.0297,0.0099 2.51843,-0.878963 4.75774,-2.060199 6.31984,-3.662885 1.56433,-1.604985 2.5136,-3.594843 2.5136,-6.463189 V 4.408527 c -3.02801,0 -6.30085,-1.6357122 -8.71728,-3.74444775 -0.0436,-0.037282 -0.0923,-0.056846 -0.14088,-0.056846 z"
      />
      <path
        fill={`url(#${stripeId})`}
        stroke="none"
        d="m 11.99998,0.60723325 c -0.0486,0 -0.0972,0.01956 -0.14088,0.05685 C 9.4545,2.7607577 6.17404,4.4085273 3.14183,4.4085273 v 8.8581517 c 0,2.868346 0.94838,4.85766 2.5136,6.460717 1.56522,1.603054 3.81148,2.782428 6.33961,3.655471 0.01,0.0032 0.0198,0.0065 0.0297,0.0099 L 14.02165,20.544575 10.01856,17.696384 14.01547,14.848192 10.01238,12 14.00929,9.1518084 10.0062,6.3036167 14.00311,3.455425 Z"
      />
    </svg>
  );
};
